import { SerializedStyles, css } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { positionElementFull } from 'src/domains/layouts/styles/Mixin.style';

import { withConfig } from 'src/withConfig';



interface PreMatchWrapperPropsType {

    bgImage?: string;

    variant: DefaultComponentVariantType | null;

}



const renderPreMatchBgImage = (bgImage: string | undefined, theme: EmotionTheme): SerializedStyles => {

    if (bgImage === undefined ) {

        return css`

            &::before {

                background-image: ${theme.star.preMatch.bgColorSecondary};

            }

        `;

    }



    return css`

        &::before {

            background-image: url(${bgImage}), ${theme.star.preMatch.bgColorSecondary};

        }

    `;

};



const setPreMatchWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            display: flex;

            gap: 6px;

            flex-flow: column nowrap;

            align-content: center;

            justify-content: center;

            @media ${theme.star.mediaQuery.desktop} {

                gap: ${theme.star.gap.medium};

            }

        `;

    }

    return css`

        padding: ${theme.star.padding.xMedium} ${theme.star.padding.large} ${theme.star.padding.large};

        @media ${theme.star.mediaQuery.desktop} {

            padding: ${theme.star.padding.large} ${theme.star.padding.xxLarge} ${theme.star.padding.xxLarge};

        }

    `;

};



/* Background container Pre match */

export const PreMatchWrapper = withConfig(theme => styled('div', { label: 'PreMatchWrapper' })<PreMatchWrapperPropsType>`

    ${({ variant }): SerializedStyles => setPreMatchWrapper(variant, theme)}

    background-color: ${theme.star.preMatch.bgColor};

    height: 72px;

    margin: auto;

    position: relative;

    text-align: center;

    width: 100%;

    z-index: ${theme.star.zIndexGlobal.base};

    &::before {

        ${positionElementFull};

        background-position: top center;

        background-size: 100% auto;

        content: '';

        position: absolute;

        z-index: ${theme.star.zIndexGlobal.below};

    }

    ${({ bgImage }): SerializedStyles => renderPreMatchBgImage(bgImage, theme)};

    @media ${theme.star.mediaQuery.desktop} {

        height: 128px;

    }

`);



interface PreMatchDatePropsType {

    variant: DefaultComponentVariantType | null;

}



const setPreMatchDateWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css``;

    }

    return css`

        margin-bottom: 6px;

        @media ${theme.star.mediaQuery.desktop} {

            margin-bottom: 8px;

        }

    `;

};



export const PreMatchDate = withConfig(theme => styled('time', { label: 'PreMatchDate' })<PreMatchDatePropsType>`

    ${({ variant }): SerializedStyles => setPreMatchDateWrapper(variant, theme)}

    color: ${theme.star.preMatch.txtColorSecondary};

    display: block;

    font-size: ${theme.star.fontSize.xSmall};

    font-weight: ${theme.star.fontWeight.medium};

    line-height: 1.2;

    @media ${theme.star.mediaQuery.desktop} {

        font-size: ${theme.star.fontSize.regular};

        font-weight: ${theme.star.fontWeight.regular};

        line-height: 1.5;

    }

`);



export const PreMatchTime = withConfig(theme => styled('span', { label: 'PreMatchTime' })`

    position: relative;

    display: inline-block;

    margin-left: 14px;

    &::before {

        background: currentcolor;

        bottom: 2px;

        content: '';

        left: -8px;

        position: absolute;

        top: 2px;

        width: 1px;

    }

    @media ${theme.star.mediaQuery.desktop} {

        &::before {

            bottom: 5px;

            top: 6px;

        }

    }

`);



export const PreMatchParticipants = styled('div', { label: 'PreMatchParticipants' })`

    align-items: center;

    display: flex;

    justify-content: center;

`;



export const PreMatchParticipantName = withConfig(theme => styled('span', { label: 'PreMatchParticipantName' })`

    color: ${theme.star.preMatch.txtColorTertiary};

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.medium};

    line-height: 1.3334;

    flex: 0 0 calc(100% - 22px);

    text-align: right;

    &:last-of-type {

        text-align: left;

    }

    @media ${theme.star.mediaQuery.desktop} {

        font-size: ${theme.star.fontSize.xMedium};

        line-height: 1.2;

        flex-basis: calc(50% - 40px);

    }

`);





interface VersusPropsType {

    variant: DefaultComponentVariantType | null;

}



export const Versus = withConfig(theme => styled('div', { label: 'Versus' })<VersusPropsType>`

    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.medium: '0'};

    align-items: center;

    background: ${theme.star.preMatch.bgColorTertiary};

    display: flex;

    flex: 0 0 24px;

    font-weight: ${theme.star.fontWeight.bold};

    height: 24px;

    justify-content: center;

    margin: 0 8px;

    &::before {

        color: ${theme.star.preMatch.txtColor};

        content: 'V';

        font-size: ${theme.star.fontSize.xRegular};

        line-height: 1.4286;

        margin-top: 2px;

    }

    @media ${theme.star.mediaQuery.desktop} {

        flex-basis: 48px;

        height: 48px;

        margin: 0 16px;

        &::before {

            font-size: ${theme.star.fontSize.medium};

            line-height: 1.3334;

            margin-top: 4px;

        }

    }

`);

